import IReloadScreenActions from '@/views/cashFlow/predictedFlow/interfaces/reloadScreenActions/IReloadScreenActions';

export default {
  namespaced: true,
  state: {
    mustSumAllValues: false,
    recalculateTotalsState: false,
    isEventSend: false,
    eventData: {},
  },
  mutations: {
    setMustSumAllValues(state: any, mustSum: boolean) {
      state.mustSumAllValues = mustSum;
    },
    triggerEventSend(state: any, eventData: IReloadScreenActions) {
      state.isEventSend = true;
      state.eventData = eventData;
    },
    emptyEvent(state: any) {
      state.isEventSend = false;
      state.eventData = {};
    },
  },
};
